import React from 'react'
import MyPayroll from './MyPayroll'


export default function MaleFemaleRatioReport() {
  return (
    <div>
      <MyPayroll />
    </div>
  )
}
